import Page from "../../components/Page";
import useFinishedList from "./hooks/useFinishedList";

const FinishedList = () => {
  const page = useFinishedList();
  return <Page {...page} />;
};

export default FinishedList;